import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import ParentLayout from '../ParentLayout';
import Urls from '../Urls';
import Form from './Form';
import useRouter from '../../../hooks/useRouter';
import useEvaluationNavigation from '../useEvaluationNavigation';

export default function Layout(props) {
  const { location, history, match } = useRouter();
  const user = useUser();
  const evaluation = useConnect('evaluationEventEducator.byId', {
    id: Number(match.params.evaluationId)
  });

  const navigation = useEvaluationNavigation(evaluation, Urls(evaluation).LEARNER_REFLECTION);

  if (evaluation.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      evaluation={evaluation}
      page="Learner Reflection"
      title={(
        <>
          How were your learners impacted as a result of this experience?
        </>
      )}
      description={(
        <>
          Please share any specific moments, comments, or changes in your students that stood out to you.
        </>
      )}
    >
      <Form
        user={user}
        evaluation={evaluation}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls(evaluation).UNFOLDED_REFLECTION)}
        onNext={(newData) => history.push(Urls(evaluation).PERSONAL_REFLECTION)}
        onSkip={() => history.push(Urls(evaluation).PERSONAL_REFLECTION)}
        onExit={() => history.push(Urls(evaluation).EVENT_VIEW)}
      />
    </ParentLayout>
  );
};
